import app from 'flarum/common/app';
import Avatar from 'flarum/common/components/Avatar';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
export default class MobileTabSessionDropdown extends SessionDropdown {
  getButtonContent() {
    const user = app.session.user;
    return [m(Avatar, {
      user: user
    }), ' ',
    // The username can be long, so it is better to display "Profile"
    m("span", {
      className: "Button-label"
    }, app.translator.trans('acpl-mobile-tab.lib.item.profile'))];
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/MobileTabSessionDropdown', MobileTabSessionDropdown);